module.exports = __webpack_public_path__ + "static/media/Logo_Royal_Rangers.858b54cc.svg";